import './WorkProjectSkeleton.scss';

const WorkProjectSkeleton = () => {

    return (
        <>
            <div className='work__project__wrapper__skeleton'>
                <div className='all__link__skeleton'>
                    <div className='all__link__text__skeleton'></div>
                </div>
                <div className='all__route__skeleton'>
                    <div className='all__link__next__skeleton'></div>
                    <div className='all__link__prev__skeleton'></div>
                </div>
                <div className='work__project__info__wrapper__skeleton'>
                    <div className='image__work__project__info__item__skeleton'>
                        <div className='image__work__project__info__item__cont__skeleton'>
                            <div className='image__work__project__info__item__accent__skeleton'></div>
                            <div className='image__work__project__info__item__accent__skeleton--primary'></div>
                            <div className='image__work__project__info__item__title__skeleton'></div>
                        </div>
                    </div>
                    <div className='description__work__project__wrapper__skeleton'>
                        <div className='description__work__project__wrapper__left__skeleton'>
                            <div className='description__work__project__wrapper__title__skeleton'></div>
                            {[...Array(6)].map((_, index) => (
                                <div key={index} className="project__list__skeleton"></div>
                            ))}
                            <div className="project__list__skeleton--primary"></div>
                        </div>
                        <div className='description__work__project__wrapper__right__skeleton'>
                            <div className='description__work__project__wrapper__title__skeleton'></div>
                            {[...Array(5)].map((_, index) => (
                                <div key={index} className="project__item__subtitle__skeleton"></div>
                            ))}
                            <div className="project__item__subtitle__skeleton--primary"></div>
                        </div>
                    </div>
                </div>
                <div className='project__info__section__wrapper__skeleton'>
                    <div className='project__info__wrapper__main__skeleton'>
                        <div className='project__info__wrapper__main__title__skeleton'></div>
                        {[...Array(2)].map((_, index) => (
                            <div key={index} className='project__info__wrapper__main__text__wrapper__skeleton'>
                                {[...Array(4)].map((_, index) => (
                                    <div key={index} className='project__info__wrapper__main__text__skeleton'></div>
                                ))}
                                <div className='project__info__wrapper__main__text__skeleton--primary'></div>
                            </div>
                        ))}
                    </div>
                    <div className='project__info__wrapper__goals__skeleton'>
                        <div className='project__info__wrapper__goals__title__skeleton'></div>
                        <div className='project__info__wrapper__goals__wrapper__skeleton'>
                            {[...Array(2)].map((_, index) => (
                                <div key={index} className='project__info__wrapper__goals__item__skeleton'>
                                    <div className='project__info__wrapper__goals__item__title__skeleton'></div>
                                    {[...Array(4)].map((_, index) => (
                                        <div key={index} className='project__info__wrapper__goals__item__text__skeleton'></div>
                                    ))}
                                    <div className='project__info__wrapper__goals__item__text__skeleton--primary'></div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='screen__wrapper__skeleton'>
                        <div className='screen__wrapper__head__skeleton'>
                            <div className='screen__wrapper__head__nav__skeleton'>
                                {[...Array(3)].map((_, index) => (
                                    <div key={index} className='screen__wrapper__head__nav__circle__skeleton'></div>
                                ))}
                            </div>
                        </div>
                        <div className='screen__wrapper__body__skeleton'>
                            <div className="screen__wrapper__body__pic__skeleton"></div>
                        </div>
                    </div>
                    {[...Array(2)].map((_, index) => (
                        <div key={index} className='project__info__wrapper__main__skeleton'>
                            <div className='project__info__wrapper__main__title__skeleton'></div>
                            {[...Array(2)].map((_, index) => (
                                <div key={index} className='project__info__wrapper__main__text__wrapper__skeleton'>
                                    {[...Array(4)].map((_, index) => (
                                        <div key={index} className='project__info__wrapper__main__text__skeleton'></div>
                                    ))}
                                    <div className='project__info__wrapper__main__text__skeleton--primary'></div>
                                </div>
                            ))}
                        </div>
                    ))}
                    <div className='project__info__wrapper__process__skeleton'>
                        <div className='design__wrapper__picture__skeleton'></div>
                    </div>
                    {[...Array(2)].map((_, index) => (
                        <div key={index} className='project__info__wrapper__main__skeleton'>
                            <div className='project__info__wrapper__main__title__skeleton'></div>
                            {[...Array(2)].map((_, index) => (
                                <div key={index} className='project__info__wrapper__main__text__wrapper__skeleton'>
                                    {[...Array(4)].map((_, index) => (
                                        <div key={index} className='project__info__wrapper__main__text__skeleton'></div>
                                    ))}
                                    <div className='project__info__wrapper__main__text__skeleton--primary'></div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            <div className='work__project__feedback__wrapper__skeleton'>
                <div className='work__project__feedback__wrapper__item__content__skeleton'>
                    <div className='work__project__feedback__wrapper__item__img__skeleton'></div>
                    {[...Array(4)].map((_, index) => (
                        <div key={index} className='work__project__feedback__wrapper__item__content__text__skeleton'></div>
                    ))}
                    <div className='work__project__feedback__wrapper__item__content__company__skeleton'>
                        <div className='work__project__feedback__wrapper__item__content__company__img__skeleton'></div>
                        <div className='work__project__feedback__wrapper__item__content__company__info__skeleton'>
                            <div className='work__project__feedback__wrapper__item__content__company__info__name__skeleton'></div>
                            <div className='work__project__feedback__wrapper__item__content__company__info__position__skeleton'></div>
                        </div>
                    </div>
                </div>
                <div className='work__project__feedback__gradient__skeleton'></div>
            </div>
            <div className='next__work__project__skeleton'>
                <div className='next__work__project__subtitle__skeleton'></div>
                <div className="next__work__project__link__skeleton"></div>
            </div>
        </>
    );
};

export default WorkProjectSkeleton;